import { CompilerSurveyInvitationModel, CompilerSurveyResponseModel, CompilerSurveyTrigger } from 'types/types';
import { axiosInstance } from './apiCommon';

export const getCompilerSurveyInvitation = async (
  epdId: string,
  trigger: CompilerSurveyTrigger
): Promise<CompilerSurveyInvitationModel> => {
  return (
    await axiosInstance.get<CompilerSurveyInvitationModel>('/api/v1/CompilerSurvey/Invitation', {
      params: { epdId, trigger },
    })
  ).data;
};

export const recordCompilerSurveyResponse = async (model: CompilerSurveyResponseModel): Promise<void> => {
  await axiosInstance.post('/api/v1/CompilerSurvey/Response', model);
};
